import { categoryI } from "app/api/category/category.types";
import { storageKey } from "app/utils/storageKeys";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const isCategoryListOpen = atom(true);

const categoryList = atomWithStorage<categoryI[]>(storageKey.category, []);

export { isCategoryListOpen, categoryList };
